import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
   name: 'ordinal',
   standalone: false,
})
export class OrdinalPipe implements PipeTransform {
   transform(value: any): string {
      value = Number(value)
      if (value === null || value === undefined || isNaN(value)) {
         return ''
      }

      const j = value % 10
      const k = value % 100

      if (j === 1 && k !== 11) return `st`
      if (j === 2 && k !== 12) return `nd`
      if (j === 3 && k !== 13) return `rd`
      return `th`
   }
}
